export const ADD_HABIT = "ADD_HABIT";
export const GET_HABIT = "GET_HABIT";
export const DELETE_HABIT = "DELETE_HABIT";
export const EDIT_HABIT = "EDIT_HABIT";
export const ADD_HABIT_ID = "ADD_HABIT_ID";
export const TICK_HABIT = "TICK_HABIT";
export const IS_LOGGED_IN = "IS_LOGGED_IN";
export const IS_NAV_OPEN = "IS_NAV_OPEN";
